import { render, staticRenderFns } from "./contenuformation.vue?vue&type=template&id=36ba0f48&scoped=true&"
import script from "./contenuformation.vue?vue&type=script&lang=js&"
export * from "./contenuformation.vue?vue&type=script&lang=js&"
import style0 from "./contenuformation.vue?vue&type=style&index=0&id=36ba0f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba0f48",
  null
  
)

export default component.exports